import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { classnames, fDate } from '@aibees/shared/utils';
import { memo } from 'react';
import { usePlanCardContext } from '../../context';
import * as Styled from './styles';
import * as SX from './sx';
import type { NextChargeTagProps as Props } from './types';

export const NextChargeTag = memo(({ className }: Props) => {
  const { selectedPlan, currentPlan, isPaid } = usePlanCardContext();
  const { data } = useCurrentSubscriptionApi();

  if ((isPaid && currentPlan?.id !== selectedPlan?.id) || !isPaid) return null;

  return (
    <Styled.Wrapper
      className={classnames('NextChargeTag', className)}
      sx={SX.root}
      label={`${
        data?.current?.cancelAtPeriodEnd ? 'Active until ' : 'Next Charge '
      }${fDate(data?.current?.currentPeriodEnd, 'dd/MM/yy')}`}
      variant="filled"
      shape="rounded"
      color="default"
      size="small"
    />
  );
});

NextChargeTag.displayName = 'NextChargeTag';
